export function formatWebVersion(commit, committedAt) {
  const validCommit = /^(?:[a-f0-9]{40}|[a-f0-9]{64})$/i.test(commit || '');
  const shortCommit = validCommit ? commit.slice(0, 7).toLowerCase() : 'Unknown';
  const date = validCommit && committedAt ? new Date(committedAt) : null;
  const dateLabel = date && Number.isFinite(date.getTime())
    ? new Intl.DateTimeFormat('en-US', {
      year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC',
    }).format(date)
    : 'Unknown';
  return { shortCommit, dateLabel, copyText: `Web: ${shortCommit} · ${dateLabel} (UTC)` };
}
